'use client';
/** @jsxImportSource @emotion/react */

import type { CardActionAreaProps } from '@mui/material/CardActionArea';

import MuiCardActionArea from '@mui/material/CardActionArea';

export type { CardActionAreaProps };
export const CardActionArea = MuiCardActionArea;
